import { render, staticRenderFns } from "./editIpBlack.vue?vue&type=template&id=22376631&scoped=true&"
import script from "./editIpBlack.vue?vue&type=script&lang=js&"
export * from "./editIpBlack.vue?vue&type=script&lang=js&"
import style0 from "./editIpBlack.vue?vue&type=style&index=0&id=22376631&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22376631",
  null
  
)

export default component.exports